


























import Breadcrumb from "@/components/Breadcrumb/index.vue";
import Hamburger from "@/components/Hamburger/index.vue";
import { Component, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import { UserModule } from "@/store/modules/user";
import { setInterval } from "timers";
import { formatDate, formatDateTime } from "../../../utils/dateUtil";

@Component({
  components: {
    Breadcrumb,
    Hamburger
  }
})
export default class Navbar extends Vue {
  private time = formatDateTime(new Date());
  get sidebar() {
    return AppModule.sidebar;
  }

  get avatar() {
    return UserModule.portrait;
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  private logout() {
    UserModule.LogOut().then(() => {
      location.reload(); // 为了重新实例化vue-router对象 避免bug
    });
  }

  public created() {
    let self = this;
    setInterval(function() {
      let date = new Date();
      self.time = formatDateTime(date);
    }, 1000);
  }
}
